export default __webpack_public_path__ + "static/media/textFileImage.84e58749.png";